module.exports = __webpack_public_path__ + "static/object-marketing-logo@3x-ce6af3b9f36424ca4b1a91dd9552ef70.png";